// extracted by mini-css-extract-plugin
export default {"container":"vq-z","brandName":"wq-z","productName":"xq-z","productNamePdpEnhancements":"yq-z","breakLongProductName":"zq-z"};